// src/components/NavbarComponents/DesktopCTAs.tsx
import { Link } from 'react-router-dom';
import { Phone, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DesktopCTAsProps {
  scrolled: boolean;
}

const DesktopCTAs = ({ scrolled }: DesktopCTAsProps) => {
  return (
    <div className="hidden lg:flex items-center space-x-4 relative z-20">
      <Button 
        variant="outline" 
        className={`flex items-center gap-2 border-white text-white hover:bg-white/20 font-semibold bg-transparent group transition-all duration-300 ${
          scrolled ? 'bg-stone-900/50 border-opacity-80' : 'bg-transparent border-opacity-100'
        }`}
        onClick={() => window.location.href = 'tel:031467272'} // Direct navigation
      >
        <Phone size={16} className="transition-transform duration-300 group-hover:translate-x-[-2px]" /> 031 467 272
      </Button>
      <Button 
        className={`flex items-center gap-2 bg-secondary hover:bg-secondary/90 font-semibold group transition-all duration-300 ${
          scrolled ? 'bg-secondary/80' : 'bg-secondary'
        }`}
        asChild // Still works with Link
      >
        <Link to="/kontakt">
          Zahtevaj ponudbo <ChevronRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Button>
    </div>
  );
};

export default DesktopCTAs;